import React from "react";
import Typography from "@material-ui/core/Typography";
const Quotation = ({}) => {
  return (
    <React.Fragment>
      <Typography paragraph variant="h4">
        Quotation
      </Typography>
      <Typography paragraph variant="h5">
        Publish the price quotation to potential customer
      </Typography>
      <Typography paragraph variant="body1">
        Quotation is one of the features under the Sales module to perform
        pre-sales transactions particularly to provide the price offering to the
        potential customers. It contains any information regarding the potential
        customer address & contact, currency & exchange rate used for the
        transaction, applied terms & conditions, form printout, and the
        quotation items detail.
      </Typography>
      <Typography paragraph variant="h5" className="mt-5">
        How it works
      </Typography>
      <Typography paragraph variant="body1">
        The first information displayed on this feature is the Quotation list.
        It is displayed like a table that contains download functions, sort,
        filter, and global search on the header area, and contains data
        navigation and refresh function on the footer area. The data column that
        appears in this table list are listed below:
      </Typography>
      <Typography paragraph variant="body1">
        <b>Quotation ID</b>
        <br />
        Indicates the ID of the Quotation.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Type</b>
        <br />
        Indicates the type of the Potential Customer. There are 2 types: Lead
        and Customer.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Name</b>
        <br />
        Indicates the name of the Potential Customer.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Quotation Date</b>
        <br />
        Indicates the quotation date of the Quotation.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Quotation Status</b>
        <br />
        Indicates the pre-sales status of the Quotation. There are 3 statuses:
        In Progress, Sales Won, and Sales Lost.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Grand Total</b>
        <br />
        Indicates the grand total of the Quotation.
      </Typography>
      <Typography paragraph variant="body1">
        Apart from the column appearing on the table list, there are more
        columns available on each row by clicking the expand button on the left
        side of each data.
      </Typography>
      <Typography paragraph variant="body1">
        Besides, there are 3 buttons and 1 approval indicator that appear on
        each row of Quotation data with specific conditions explained below:
      </Typography>
      <Typography paragraph variant="body1">
        <b>Edit Quotation</b>
        <br />
        This button only appears if the Quotation status is 'In Progress' and
        the approval indicator is not 'Document Waiting For Approval'. It is
        used to edit the Quotation data.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Quotation Detail</b>
        <br />
        This button is used to navigate to the Quotation detail which contains
        some tabs with details below:
        <ul>
          <li>
            <b>Basic Info</b> : This tab is to display the Quotation data.
          </li>
          <li>
            <b>DP Invoice</b> : This tab is to display any Down Payment Invoice
            related to the Quotation.
          </li>
          <li>
            <b>Attachments</b> : This tab is to display any Attachments related
            to the Quotation.
          </li>
          <li>
            <b>Notes</b> : This tab is to display any Notes related to the
            Quotation.
          </li>
          <li>
            <b>PrintOut</b> : This tab is to display any PrintOut related to the
            Quotation.
          </li>
        </ul>
        When opening the Quotation detail, there will be 3 buttons appearing on
        the top section. The first button is 'Edit Quotation' which is used to
        edit the Quotation data. The second button is 'Sales Lost' which is used
        to mark the Quotation as a deal lost. The third button is 'Sales Won'
        which is used to mark the Quotation as a deal won and convert the
        Quotation to be Sales Order automatically. Both 3 buttons only appear
        when the Quotation status is 'In Progress' and the approval indicator is
        not 'Document Waiting For Approval'.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Delete Quotation</b>
        <br />
        This button only appears if the Quotation status is 'In Progress' and
        the approval indicator is not 'Document Waiting For Approval'. It is
        used to delete the Quotation data. The Quotation data is undeletable
        once it has relations with other documents.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Approval Indicator</b>
        <br />
        The Quotation document could have an approval flow if it is configured.
        The approval indicator appears as an icon after the document ID. There
        are 4 approval indicators: Document No Need Approval, Document Waiting
        For Approval, Document Approved, and Document Rejected.
      </Typography>
    </React.Fragment>
  );
};

export default Quotation;
